// Classname concatination utility
export function cx(...args: (string | undefined | false | null)[]) {
  return args.filter((s) => !!s).join(` `)
}
